import { useEffect, useState } from "react";

import { loadMeta } from "./data";
import { PlanFinder } from "./PlanFinder";
import { QaReport } from "./QaReport";
import { ThemeToggle } from "./ThemeToggle";
import type { Meta } from "./types";

type Route = "finder" | "qa";

function routeFromHash(): Route {
  return window.location.hash.replace(/^#\/?/, "") === "qa" ? "qa" : "finder";
}

export function App() {
  // Hash routing rather than history routing: it works on any static host
  // without a redirect rule, which keeps deployment to a plain file upload.
  const [route, setRoute] = useState<Route>(routeFromHash);
  const [meta, setMeta] = useState<Meta | null>(null);

  useEffect(() => {
    const onHashChange = () => setRoute(routeFromHash());
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  useEffect(() => {
    loadMeta().then(setMeta).catch(() => setMeta(null));
  }, []);

  return (
    <div className="app">
      <header>
        <div className="brand">
          <img className="logo" src="/bulbee.png" alt="" />
          <div>
            <h1>Texas Rate Finder</h1>
            <p>Texas electricity plans priced for the power you actually use</p>
          </div>
        </div>
        <nav>
          <a className={route === "finder" ? "active" : ""} href="#/">
            Find a plan
          </a>
          <a className={route === "qa" ? "active" : ""} href="#/qa">
            Data quality
          </a>
        </nav>
      </header>
      <div className="theme-corner">
        <ThemeToggle />
      </div>

      <main>{route === "qa" ? <QaReport /> : <PlanFinder />}</main>

      <footer>
        {meta ? (
          <span>
            {meta.plan_count.toLocaleString()} plans across {meta.zip_count.toLocaleString()} ZIP
            codes, refreshed {new Date(meta.generated_at).toLocaleString()}.
          </span>
        ) : (
          <span>Plan data from Power to Choose, the PUCT's official comparison site.</span>
        )}
        <span>
          Always read the Electricity Facts Label before enrolling. Prices exclude taxes and
          non-recurring fees.
        </span>
      </footer>
    </div>
  );
}
